import { loadTheme, getCurrentThemeId } from 'owa-theme';
export default function previewDarkModeTheme(isDarkModeTheme) {
    loadTheme(getCurrentThemeId(), isDarkModeTheme);
}
//# sourceMappingURL=previewDarkModeTheme.js.map